import React from 'react';

/**
 * Production-Ready SEO Component for React 19.
 * Leverages React 19 native metadata and script hoisting to the document head.
 */
const SEO = ({
  title,
  description,
  canonicalUrl = 'https://www.isaacgroup.net',
  ogTitle,
  ogDescription,
  ogImage = 'https://www.isaacgroup.net/logo512.png',
  ogType = 'website',
  robots = 'index, follow',
  author = 'ISAAC Logistic Solutions India Pvt. Ltd.',
  themeColor = '#07080D',
  siteName = 'ISAAC Logistic Solutions',
  locale = 'en_IN',
  schema
}) => {
  const displayTitle = title
    ? (title.includes('ISAAC') ? title : `${title} | ISAAC Logistic Solutions`)
    : 'ISAAC Logistic Solutions India Pvt. Ltd. | Logistics Company in Thoothukudi';

  const defaultDescription = description || 
    'ISAAC Logistic Solutions is a premier women-led shipping agency and logistics company in Thoothukudi, Tamil Nadu. Delivering vessel husbanding, project cargo, freight forwarding, customs clearance, and green port energy solutions.';

  return (
    <>
      {/* Primary Page Tags */}
      <title>{displayTitle}</title>
      <meta name="description" content={defaultDescription} />
      <meta name="robots" content={robots} />
      <meta name="author" content={author} />
      <meta name="theme-color" content={themeColor} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />
      <meta property="og:title" content={ogTitle || displayTitle} />
      <meta property="og:description" content={ogDescription || defaultDescription} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={ogTitle || displayTitle} />
      <meta name="twitter:description" content={ogDescription || defaultDescription} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        Array.isArray(schema) ? (
          schema.map((s, index) => (
            <script
              key={index}
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
            />
          ))
        ) : (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        )
      )}
    </>
  );
};

export default SEO;
